<template>
  <div class="app-container warpp" style="height: calc(100vh - 170px); overflow-y: auto">
    <el-collapse v-model="activeNames" @change="handleChange">
      <el-collapse-item :title="$t('customerManagements.otherInformation')" name="1">
        <el-form ref="formDataOther" :model="formData" label-position="top">
          <el-row :gutter="20">
            <el-col :span="12">
              <!--返回单号规则-->
              <el-form-item
                :label="$t('customerManagements.orderNumberType')"
                :rules="[
                  {
                    required: true,
                    message: $t('customerManagements.pleaseInput'),
                    trigger: ['blur', 'change']
                  }
                ]"
                prop="orderNumberType"
              >
                <el-select
                  v-model="formData.orderNumberType"
                  :placeholder="$t('customerManagements.default')"
                  style="width: 300px"
                >
                  <el-option :key="1" :value="1" label="AJ" />
                  <el-option :key="2" :value="2" label="ANJBR" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--是否启用配货单-->
              <el-form-item
                :label="$t('customerManagements.enableDistributionOrder')"
                prop="deliveryNoteFlag"
              >
                <el-select
                  v-model="formData.deliveryNoteFlag"
                  :placeholder="$t('customerManagements.default')"
                  style="width: 300px"
                >
                  <el-option :key="0" :label="$t('GlobalSetObj.disable')" :value="0" />
                  <el-option :key="1" :label="$t('GlobalSetObj.enable')" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <!-- 是否启用轨迹停更预警 -->
              <el-form-item :label="$t('trajectory.enableTrackingAlert')" prop="isTrackStopAlert">
                <el-select
                  v-model="formData.isTrackStopAlert"
                  :placeholder="$t('customerManagements.pleaseChoose')"
                  style="width: 300px"
                >
                  <el-option :key="0" :label="$t('GlobalSetObj.disable')" :value="0" />
                  <el-option :key="1" :label="$t('GlobalSetObj.enable')" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--轨迹停更时长预警阈值-->
              <el-form-item
                :label="$t('trajectory.trackingDurationThreshold')"
                prop="trackStopAlertDays"
              >
                <el-select
                  v-model="formData.trackStopAlertDays"
                  :placeholder="$t('customerManagements.pleaseChoose')"
                  style="width: 300px"
                >
                  <el-option
                    v-for="item in 19"
                    :key="item"
                    :label="item + 1 + $t('WorkCentreTable.Day')"
                    :value="item + 1"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 退件模式 -->
              <el-form-item
                :label="$t('customerManagements.returnMode')"
                :rules="[
                  {
                    required: true,
                    message: $t('customerManagements.pleaseChoose'),
                    trigger: ['blur', 'change']
                  }
                ]"
                prop="reverseType"
              >
                <el-select
                  v-model="formData.reverseType"
                  :placeholder="$t('customerManagements.pleaseChoose')"
                  style="width: 300px" clearable
                >
                  <!--  退件模式   0-退件至平台仓库、1-新单退回、2-原单退回-D2D  -->
                  <el-option key="1" :label="$t('customerManagements.returnToPlatformWarehouse')" :value="0" />
                  <el-option key="2" :label="$t('trajectory.newOrderReturn')" :value="1" />
                  <el-option key="3" :label="$t('trajectory.originalOrderReturnD2D')" :value="2" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
    <div
      v-if="customer.type === 'edit' || customer.type === 'add'"
      slot="footer"
      class="dialog-footer"
      style="text-align: right; margin-top: 15px"
    >
      <el-button @click="clearData()">{{ $t('customerManagements.cancel') }}</el-button>
      <el-button
        type="primary" @click="onSubmit()"
      >{{ $t('customerManagements.confirm') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { apiCustomerEditOther } from '@/api/customer';

export default {
  name: 'OtherInformation',
  props: {
    detailData: {
      type: Object,
      default() {
        return {};
      }
    },
    customer: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formData: {
        orderNumberType: 1,
        deliveryNoteFlag: 0,
        isTrackStopAlert: 0, // 是否启用轨迹停更预警：0-否，1-是
        trackStopAlertDays: '', // 轨迹停更时长预警阈值（天）
        reverseType: 0
      },
      activeNames: ['1']
    };
  },
  mounted() {
    const detailData = this.detailData || {};
    this.formData = {
      orderNumberType: detailData.orderNumberType,
      deliveryNoteFlag: detailData.deliveryNoteFlag,
      customerId: detailData.id,
      isTrackStopAlert: detailData.isTrackStopAlert,
      trackStopAlertDays: detailData.trackStopAlertDays,
      reverseType: detailData.reverseType || 0
    };
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },
    // 取消
    clearData() {
      this.$emit('updataData', true);
    },
    // 提交
    onSubmit() {
      this.$refs['formDataOther'].validate((valid) => {
        if (valid) {
          const formData = {
            customerId: this.detailData.id,
            customerConfig: {
              orderNumberType: this.formData.orderNumberType,
              deliveryNoteFlag: this.formData.deliveryNoteFlag || 0,
              isTrackStopAlert: this.formData.isTrackStopAlert,
              trackStopAlertDays: this.formData.trackStopAlertDays || '',
              reverseType: this.formData.reverseType || 0
            }
          };
          apiCustomerEditOther(formData).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: this.$t('customerManagements.ModificationSuccessful'),
                type: 'success'
              });
              this.$emit('updataData');
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.warpp /deep/ .el-collapse-item__header {
  color: #00A551;
  font-size: 16px;
}

.warpp /deep/ .el-descriptions-item__label {
  font-size: 13px;
  color: #909399;
}

.warpp /deep/ .el-descriptions-item__cell {
  /*height: 35px !important;*/
  padding-bottom: 2px !important;
}
</style>
